import styled, { css } from 'styled-components';

import SecondaryButton from '~src/shared/buttons/basicButtons/SecondaryButton.sc';
import { media } from '~src/styles/media-templates';

export const MsgButton = styled(SecondaryButton)`
  ${media.phone`
    display: none;
  `}
`;

export const NoSurveyContainer = styled.div`
  ${({ theme }) => css`
    height: 100%;
    width: 100%;
    ${media.phone`
      padding: 30px 15px;
      background-color: ${theme.mobileBlue.a10};
    `}
  `}
`;
